import mentor_kjh from "public/images/people/mentor_kjh.png";
import mentor_leb from "public/images/people/mentor_leb.png";
import mentor_hsy from "public/images/people/mentor_hsy.png";

import { StaticImageData } from "next/legacy/image";

export const mentorData: {
  specialty: string;
  career: string[];
  img: StaticImageData;
  imgWidth: number;
  firstDesc: string;
  name: string;
  secondDesc: string;
  id: number;
  title: string;
}[] = [
  {
    id: 1,
    name: "김정훈 멘토",
    specialty: "마케팅 전략 / 브랜드 마케팅",
    career: [
      "현) 팀스파르타 마케팅 팀장",
      "전) 팀스파르타 브랜드 마케팅 리드",
      "전) 연합뉴스 PD",
      "중앙대학교 영화학과 졸",
    ],
    img: mentor_kjh,
    imgWidth: 132,
    title:
      "“브랜드 마케팅의 전략적 접근부터\n" +
      "데이터 기반의 성과측정과 개선까지.”",
    firstDesc:
      "팀스파르타가 10명이 채 되지 않을 때, 첫 번째 마케터로 합류했고, 회사와 개인이 함께 빠르게 성장해왔습니다. 이제는 마케팅팀만 25명이 넘었고, 회사는 10배 이상 성장했습니다. 이 과정에서 오직 성공만이 있었던 것은 아니었습니다. ",
    secondDesc:
      "다양한 성공과 실패, 성장을 통해 축적된 노하우의 핵심을 공유드릴게요. ",
  },
  {
    id: 2,
    name: "이은비 멘토",
    specialty: "그로스 해킹",
    career: [
      "현) 팀스파르타 부트캠프2팀 팀장",
      "전) 미소 HC사업부 팀장",
      "전) 데일리호텔 국내호텔팀 팀장",
      "국민대 법학과 졸",
    ],
    img: mentor_leb,
    imgWidth: 160,
    title: "“데이터 기반의 의사결정. 기본기지만, 잘 하기는 쉽지 않습니다.”",
    firstDesc:
      "사실 데이터 보는 방법은 인터넷에만 찾아봐도 많습니다. 단, 굉장히 많은 시행착오와 배경 지식을 필요로 합니다. 제가 있었던 회사들은 모두 폭발적으로 성장해왔고, 모두 데이터기반 의사결정이 강한 회사들이었는데요. ",
    secondDesc:
      "10년 이상의 다양한 경력을 통해 축적된 데이터 기반 의사결정 노하우를 알려드릴게요.",
  },
  {
    id: 3,
    name: "황순영 멘토",
    specialty: "퍼포먼스 마케팅 / 마케팅 전략",
    career: [
      "현) 팀스파르타 그로스 총괄 \n" + "       & 공동창업자",
      "전) 팀스파르타 마케팅 총괄",
      "전) 미소 신사업 매니저",
      "고려대학교 정치외교학과 졸",
    ],
    img: mentor_hsy,
    imgWidth: 160,
    title:
      "“캠페인 구조는 전략을 담아야 합니다.\n" +
      "예산 집행의 전략을 알려드릴게요.”",
    firstDesc:
      "2년여 만에 10만명이 넘는 수강생분들과 함께 했고, 구글과 메타에서 Best Practice로 선정되었습니다. 창업가 마케터로써, 제작 리소스가 없는 환경에서 다양한 실험을 통해 오직 광고관리자 세팅만으로 성장을 이끌기도 했습니다.",
    secondDesc:
      "포지셔닝 전략 수립부터 실용적인 캠페인 관리 노하우까지, 오직 SW캠프에서만 말씀드리겠습니다.",
  },
];
